import { useState, useCallback } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

function ActionMenuTemplate({ actions, anchorEl, setAnchorEl }) {
  const menuOpen = Boolean(anchorEl);
  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleClose}>
      {actions.map((action, i) => {
        const { label, onClick, ...props } = action;
        return (
          <MenuItem
            key={i}
            disabled={action.disabled || false}
            onClick={(event) => {
              event.stopPropagation();
              if (onClick) {
                onClick(event);
              }
              handleClose(event);
            }}
            {...props}
          >
            {label}
          </MenuItem>
        );
      })}
    </Menu>
  );
}

export default function useActionMenu({ actions }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const ActionMenu = useCallback(() => {
    return (
      <ActionMenuTemplate
        actions={actions}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
      />
    );
  }, [actions, anchorEl]);

  return {
    handleOpen,
    ActionMenu,
  };
}
